import { Button } from '@/components/ui/button';
import { GlowCard } from '@/components/ui/glow-card';
import { motion } from 'motion/react';
import * as React from 'react';

export default function MoreThanAnAgency() {
  const [color, setColor] = React.useState('#7877c6');
  const [opacity, setOpacity] = React.useState(0.7);

  const glowColor = `rgba(${Number.parseInt(color.slice(1, 3), 16)}, ${Number.parseInt(color.slice(3, 5), 16)}, ${Number.parseInt(color.slice(5, 7), 16)}, ${opacity})`;

  return (
    <section className="container py-12 md:py-24 lg:py-32">
      <GlowCard className="p-6 h-[300px]" glowColor={glowColor}>
        <div className="h-full flex flex-col">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-xl font-bold text-white">Premium Plan</h3>
              <p className="text-gray-400 mt-1">Get access to all features</p>
            </div>
            {/* <Sparkles className="text-purple-400 h-6 w-6" /> */}
          </div>

          <div className="mt-6 flex-1">
            <div className="text-3xl font-bold text-white">
              $29<span className="text-lg font-normal text-gray-400">/month</span>
            </div>
            <ul className="mt-4 space-y-2">
              <li className="flex items-center text-gray-300">
                {/* <Zap className="h-4 w-4 mr-2 text-purple-400" /> */}
                Unlimited projects
              </li>
              <li className="flex items-center text-gray-300">
                {/* <Zap className="h-4 w-4 mr-2 text-purple-400" /> */}
                Priority support
              </li>
              <li className="flex items-center text-gray-300">
                {/* <Zap className="h-4 w-4 mr-2 text-purple-400" /> */}
                Custom domains
              </li>
            </ul>
          </div>

          <Button className="mt-auto w-full bg-purple-600 hover:bg-purple-700">Get Started</Button>
        </div>
      </GlowCard>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="mx-auto flex max-w-[58rem] flex-col items-center justify-center gap-4 text-center"
      >
        <h2 className="text-3xl font-bold leading-[1.1] sm:text-3xl md:text-5xl">Ready to get started?</h2>
        <p className="max-w-[85%] leading-normal text-muted-foreground sm:text-lg sm:leading-7">
          Create your first Discord bot in minutes. No credit card required.
        </p>
        <Button size="lg" className="mt-4">
          Start Building Now
        </Button>
      </motion.div>
    </section>
  );
}
